export default {
  en: {
    ' · пробный период до {date}': ' · trial until {date}',
    ', последний пересчёт — {time}': ', last recalculated {time}',
    '// Без idempotencyKey SDK сам ставит ключ — повтор при сбое сети не создаст второе событие.': '// Without idempotencyKey the SDK sets a key itself, so a retry after a network failure will not create a second event.',
    '// Проверка подписи (Node.js)': '// Verify the signature (Node.js)',
    '11 000 метров — глубже только ваши метрики. Аккаунт готов принимать трафик.': '11,000 meters — only your metrics go deeper. The account is ready to receive traffic.',
    'AI': 'AI',
    'AI-доработка выключена: не задан ANTHROPIC_API_KEY': 'AI rewrite is off: ANTHROPIC_API_KEY is not set',
    'AI-доработка текста (выключена)': 'AI text rewrite (off)',
    'AI-доработка текста: {model}': 'AI text rewrite: {model}',
    'AI-пересказ выключен': 'AI summary is off',
    'AI-пересказ: {model}': 'AI summary: {model}',
    'API-ключ': 'API key',
    'API-ключ даёт серверу право отправлять письма. Мы храним только его хеш — показать ключ повторно не сможем.': 'An API key lets your server send emails. We store only its hash, so we cannot show the key again.',
    'API-ключи': 'API keys',
    'Backend production': 'Backend production',
    'Email, начало адреса или external_id': 'Email, start of an address or external_id',
    'Hard bounce': 'Hard bounce',
    'MailOcean не меняет DNS сам: добавьте запись у вашего DNS-провайдера и нажмите «Проверить DNS» на странице домена.': 'MailOcean does not change DNS itself: add the record at your DNS provider and click “Check DNS” on the domain page.',
    'MailOcean сообщит вашему бэкенду о доставке, отскоках и жалобах. Каждый запрос подписан HMAC-SHA256.': 'MailOcean will notify your backend about deliveries, bounces and complaints. Every request is signed with HMAC-SHA256.',
    'URL эндпоинта': 'Endpoint URL',
    'hello@ваш-домен.com': 'hello@your-domain.com',
    'id пользователя в вашей системе; нужен email или external_id': 'the user ID in your system; an email or external_id is required',
    'v{v} · {where} · {when}': 'v{v} · {where} · {when}',
    '{a} из {b} ключей': '{a} of {b} keys',
    '{base} (может быть, {guess}?)': '{base} (maybe {guess}?)',
    '{n} писем в месяц': '{n} emails per month',
    '{n} событий': '{n} events',
    '{scope} ({reason})': '{scope} ({reason})',
    '{sum} / мес.': '{sum} / mo',
    'Адрес в подавлениях: {list}.': 'Address on the suppression list: {list}.',
    'Аккаунт и рабочее пространство за минуту.': 'An account and a workspace in a minute.',
    'Аккаунт с этим email уже существует': 'An account with this email already exists',
    'Алиас': 'Alias',
    'Атрибутов нет.': 'No attributes.',
    'Атрибуты': 'Attributes',
    'Атрибуты (JSON)': 'Attributes (JSON)',
    'Атрибуты — JSON-объект, например { "plan": "pro" }': 'Attributes must be a JSON object, for example { "plan": "pro" }',
    'Без AI: готовые архетипы': 'No AI: ready-made archetypes',
    'Бездна: события в ваш сервер': 'Abyss: events to your server',
    'Боевой': 'Live',
    'Ваше имя': 'Your name',
    'Введите {what} для подтверждения': 'Enter {what} to confirm',
    'Вебхук создан: {url}': 'Webhook created: {url}',
    'Вебхуки': 'Webhooks',
    'Вложения': 'Attachments',
    'Возможно, он удалён по запросу субъекта данных.': 'It may have been deleted at a data subject’s request.',
    'Войдите, чтобы продолжить.': 'Sign in to continue.',
    'Войти': 'Sign in',
    'Войти с passkey': 'Sign in with passkey',
    'Вопрос': 'Question',
    'Впервые здесь?': 'New here?',
    'Все': 'All',
    'Все домены': 'All domains',
    'Все контакты': 'All contacts',
    'Все письма': 'All emails',
    'Все потоки': 'All streams',
    'Все шаблоны': 'All templates',
    'Вы в океане': 'You are in the ocean',
    'Вы превысили включённый объём. Письма продолжают отправляться; разница войдёт в следующий счёт.': 'You have exceeded the included volume. Emails keep sending; the difference will be added to the next invoice.',
    'Выставлен: {date}': 'Issued: {date}',
    'ГЛУБИНА {d}': 'DEPTH {d}',
    'Глубже': 'Deeper',
    'Глубина: первое письмо': 'Depth: first email',
    'Готово, я сохранил': 'Done, I saved it',
    'Дальше': 'Next',
    'Действие': 'Action',
    'Детали': 'Details',
    'Детектив логов': 'Log detective',
    'Добавить': 'Add',
    'Добавить домен': 'Add domain',
    'Добавлен': 'Added',
    'Добавлен:': 'Added:',
    'Добавьте домен, чтобы письма приходили от вашего имени и проходили SPF и DKIM.': 'Add a domain so emails come from your name and pass SPF and DKIM.',
    'Добавьте их у вашего DNS-провайдера': 'Add them at your DNS provider',
    'Добро пожаловать на поверхность, {name} 👋': 'Welcome to the surface, {name} 👋',
    'Доброе утро': 'Good morning',
    'Добрый вечер': 'Good evening',
    'Добрый день': 'Good afternoon',
    'Доказательство': 'Evidence',
    'Домен': 'Domain',
    'Домен {name}': 'Domain {name}',
    'Домен отправки': 'Sending domain',
    'Домен подтверждён 🌊': 'Domain verified 🌊',
    'Домен подтверждён. Письма будут подписаны DKIM и пройдут SPF.': 'Domain verified. Emails will be signed with DKIM and pass SPF.',
    'Домен удалён': 'Domain deleted',
    'Домены': 'Domains',
    'Домены, от имени которых вы отправляете письма. Подтверждённый домен подписывает каждое письмо DKIM.': 'The domains you send emails from. A verified domain signs every email with DKIM.',
    'Доработать текст моделью': 'Rewrite the text with the model',
    'Доработать текст моделью (вёрстка, ссылки и переменные не меняются)': 'Rewrite the text with the model (layout, links and variables stay unchanged)',
    'Другие проблемы за период': 'Other issues in the period',
    'Если у домена уже есть SPF-запись, не создавайте вторую — добавьте': 'If the domain already has an SPF record, do not create a second one — add',
    'Есть': 'Yes',
    'Ещё один шаг': 'One more step',
    'Жалобы': 'Complaints',
    'Ждём DNS': 'Waiting for DNS',
    'Журнал действий': 'Activity log',
    'За неделю событий не было.': 'No events this week.',
    'Забыли пароль?': 'Forgot password?',
    'Загружаем…': 'Loading…',
    'Загружаю…': 'Loading…',
    'Загрузить ещё': 'Load more',
    'Задайте вопрос о доставке': 'Ask a delivery question',
    'Задержка p95': 'p95 latency',
    'Записано': 'Recorded',
    'Записать': 'Save',
    'Записей не найдено': 'No records found',
    'Записей нет.': 'No records.',
    'Записи пока не найдены': 'Records not found yet',
    'Запись': 'Record',
    'Запись о согласии': 'Consent record',
    'Здесь появится путь письма: приём API → очередь → передача провайдеру → ответ провайдера.': 'The email’s path will appear here: API intake → queue → handoff to the provider → provider response.',
    'Здесь появятся действия команды и API-ключей.': 'Team and API key actions will appear here.',
    'Здоровье падает от отскоков, жалоб, ошибок и отсутствия подтверждённого домена — тех же сигналов, по которым почтовики решают, куда класть письма.': 'Health drops with bounces, complaints, errors and a missing verified domain — the same signals mailbox providers use to decide where to place emails.',
    'Значение': 'Value',
    'Идемпотентный API: повтор запроса не создаёт дубль': 'Idempotent API: a repeated request does not create a duplicate',
    'Изменения DNS обычно применяются за 5–30 минут, иногда до 48 часов. Можно продолжить: первое тестовое письмо мы отправим с домена {domain}.': 'DNS changes usually apply within 5–30 minutes, sometimes up to 48 hours. You can continue: we will send the first test email from the domain {domain}.',
    'Изменён:': 'Updated:',
    'Имя (host)': 'Name (host)',
    'Имя в шапке и подписи': 'Shown in the header and signature',
    'Использован': 'Last used',
    'Использовано писем за месяц': 'Emails used this month',
    'Источник': 'Source',
    'Источник: {source}': 'Source: {source}',
    'Исход неизвестен': 'Outcome unknown',
    'Итого': 'Total',
    'К оплате': 'Amount due',
    'Каждое письмо и его путь — от приёма API до ответа почтового сервера.': 'Every email and its path — from API intake to the mail server’s response.',
    'Каждое письмо — ': 'Every email is a ',
    'Как в описании': 'As in the description',
    'Как оплатить': 'How to pay',
    'Как передать событие': 'How to send an event',
    'Как получено': 'How it was obtained',
    'Какое письмо нужно': 'Which email do you need',
    'Ключ': 'Key',
    'Ключ «{name}» создан': 'Key «{name}» created',
    'Ключ атрибута': 'Attribute key',
    'Ключ объявлен': 'Key declared',
    'Ключ отозван': 'Key revoked',
    'Ключ уже создан. Новые ключи — в разделе «API-ключи» бэкофиса.': 'The key has already been created. New keys are in the “API keys” section of the back office.',
    'Ключей пока нет': 'No keys yet',
    'Ключи для серверов. Храним только хеш: потерянный ключ не восстановить — отзовите и создайте новый.': 'Keys for your servers. We store only the hash: a lost key cannot be recovered — revoke it and create a new one.',
    'Ключи появятся с первыми контактами. Строка, похожая на дату, остаётся строкой — дату объявите заранее.': 'Keys will appear with the first contacts. A string that looks like a date stays a string — declare dates in advance.',
    'Кнопки и ссылки; контраст текста подбирается сам': 'Buttons and links; text contrast is adjusted automatically',
    'Когда': 'When',
    'Кол-во': 'Qty',
    'Комментарий для менеджера': 'Comment for the manager',
    'Компания': 'Company',
    'Кому': 'To',
    'Контакт': 'Contact',
    'Контакт добавлен': 'Contact added',
    'Контакт не найден': 'Contact not found',
    'Контакт не участвовал в сценариях.': 'The contact has not taken part in any journeys.',
    'Контакт удалён. Квитанция без персональных данных сохранена.': 'Contact deleted. A receipt without personal data has been kept.',
    'Контактов пока нет': 'No contacts yet',
    'Контакты': 'Contacts',
    'Копировать значение': 'Copy value',
    'Копия': 'Cc',
    'Кто': 'Who',
    'Кто, что и когда изменил: люди и API-ключи. Пароли, токены и секреты сюда не попадают.': 'Who changed what and when: people and API keys. Passwords, tokens and secrets never end up here.',
    'Куда': 'Where to',
    'Локаль:': 'Locale:',
    'Лучше поддомен, например mail.example.com': 'A subdomain is better, for example mail.example.com',
    'Люди, которым вы пишете: идентификаторы, атрибуты, согласие на маркетинг и события. Профили не склеиваются сами — конфликт идентификаторов возвращается ошибкой.': 'The people you write to: identifiers, attributes, marketing consent and events. Profiles are not merged automatically — an identifier conflict returns an error.',
    'Маркетинг': 'Marketing',
    'Маркетинговые': 'Marketing',
    'Маркетинговый': 'Marketing',
    'Минимально необходимые права уменьшают ущерб при утечке': 'The fewest necessary permissions reduce the damage if a key leaks',
    'Минимум 10 символов': 'At least 10 characters',
    'Модель только пересказывает найденные факты': 'The model only restates the facts found',
    'НДС': 'VAT',
    'На бесплатном тарифе счета не выставляются. После смены тарифа менеджер пришлёт счёт — он появится здесь.': 'Invoices are not issued on the free plan. After a plan change the manager will send an invoice, and it will appear here.',
    'На дно': 'To the bottom',
    'Назад': 'Back',
    'Название': 'Name',
    'Название ключа': 'Key name',
    'Например: «Backend production» или «Staging»': 'For example: “Backend production” or “Staging”',
    'Например: «код подтверждения входа, живёт 10 минут» или «receipt after payment»': 'For example: “sign-in verification code, valid for 10 minutes” or “receipt after payment”',
    'Например: почему падают письма на Apple? или msg_… — что с этим письмом?': 'For example: why are emails to Apple failing? Or msg_… — what is wrong with this email?',
    'Настрою позже': 'I’ll set it up later',
    'Начало периода': 'Period start',
    'Начало периода (необязательно)': 'Period start (optional)',
    'Начать погружение': 'Start the dive',
    'Не отправлено подавленным адресам: {list}': 'Not sent to suppressed addresses: {list}',
    'Не получилось отправить заявку': 'The request could not be sent',
    'Не удалось загрузить данные о тарифе: {msg}': 'Could not load plan details: {msg}',
    'Не хватает переменных: {list}': 'Missing variables: {list}',
    'Неверный email или пароль': 'Wrong email or password',
    'Необязательно: ожидаемый объём, реквизиты компании, удобное время для связи': 'Optional: expected volume, company details, a convenient time to call',
    'Нет': 'No',
    'Нет HTML-версии': 'No HTML version',
    'Нет записи о согласии — маркетинг не отправляется': 'No consent record — marketing is not sent',
    'Нет текстовой версии': 'No text version',
    'Никого не нашли': 'No one found',
    'Ничего не найдено': 'Nothing found',
    'Новая версия существующего шаблона сразу начнёт использоваться при отправке по его алиасу': 'A new version of an existing template is used immediately when sending by its alias',
    'Новая версия: {name} ({alias}, сейчас v{v})': 'New version: {name} ({alias}, currently v{v})',
    'Новый API-ключ': 'New API key',
    'Новый домен': 'New domain',
    'Новый ключ': 'New key',
    'Новый ключ получает тип по первому значению': 'A new key gets its type from the first value',
    'Новый контакт': 'New contact',
    'Новый шаблон (v1)': 'New template (v1)',
    'Номер': 'Number',
    'Нужен, чтобы подсказать домен отправки': 'Used to suggest a sending domain',
    'Нырнуть глубже': 'Dive deeper',
    'Ныряем…': 'Diving…',
    'Обновить': 'Refresh',
    'Обновляется каждые 15 минут': 'Updated every 15 minutes',
    'Объект': 'Object',
    'Объявить': 'Declare',
    'Объём в месяц': 'Volume per month',
    'Обязательно: это доказательство на случай проверки': 'Required: this is your evidence in case of an audit',
    'Океан пока спокоен': 'The ocean is calm for now',
    'Опишите письмо словами — получите черновик шаблона: светлая и тёмная тема, текстовая версия, переменные и код отправки. Черновик ничего не отправляет: шаблоном он станет только после публикации.': 'Describe the email in words and get a template draft: light and dark themes, a text version, variables and sending code. A draft sends nothing: it becomes a template only after publishing.',
    'Оплата фиксируется вручную после поступления перевода. Автоматического списания нет.': 'Payment is recorded manually once the transfer arrives. There are no automatic charges.',
    'Оплатить до: {date}': 'Pay by: {date}',
    'Оплату отмечает финансовый отдел MailOcean после поступления перевода — обычно в течение рабочего дня.': 'MailOcean’s finance team marks the payment once the transfer arrives — usually within a business day.',
    'Оплачено': 'Paid',
    'Оповещения': 'Alerts',
    'Определить по описанию': 'Detect from the description',
    'Опубликовано: {alias} v{v}': 'Published: {alias} v{v}',
    'Опубликовать': 'Publish',
    'Опубликовать {what}': 'Publish {what}',
    'Осталось шагов: {n}. Каждый из них приближает письма к «Входящим».': 'Steps left: {n}. Each one brings your emails closer to the inbox.',
    'От': 'From',
    'Ответить': 'Reply-to',
    'Ответы собираются без модели': 'Answers are assembled without the model',
    'Отзыв': 'Withdrawal',
    'Открыть бэкофис': 'Open the back office',
    'Отмена': 'Cancel',
    'Отозвано': 'Withdrawn',
    'Отозвать': 'Revoke',
    'Отозвать ключ «{name}»? Запросы с ним сразу начнут получать 401.': 'Revoke key «{name}»? Requests with it will get 401 immediately.',
    'Отправим тестовое письмо на': 'We will send a test email to',
    'Отправить заявку': 'Send request',
    'Отправить себе письмо': 'Send myself an email',
    'Отправка из кода': 'Sending from code',
    'Отправляем…': 'Sending…',
    'Отправьте первое письмо через API — оно появится здесь через мгновение.': 'Send your first email through the API — it will appear here in a moment.',
    'Отскоки': 'Bounces',
    'Пара вопросов, чтобы настроить океан под ваш продукт. Это займёт меньше минуты.': 'A couple of questions to tune the ocean to your product. It takes less than a minute.',
    'Пароль': 'Password',
    'Первая волна дошла до провайдера за {ms} мс.': 'The first wave reached the provider in {ms} ms.',
    'Первое письмо': 'First email',
    'Передайте их из своего приложения — одним вызовом при регистрации или оформлении заказа. Повторный вызов обновляет контакт.': 'Send them from your app in a single call at sign-up or checkout. A repeated call updates the contact.',
    'Передайте первое событие из приложения — пример справа.': 'Send the first event from your app — see the example on the right.',
    'Переменные:': 'Variables:',
    'Период': 'Period',
    'Период: {from} — {to}': 'Period: {from} — {to}',
    'Печать / PDF': 'Print / PDF',
    'Писем': 'Emails',
    'Письма': 'Emails',
    'Письма должны приходить от вашего имени и проходить проверки Gmail, Outlook и Яндекса. Добавьте три DNS-записи — мы сгенерировали для вас ключ DKIM.': 'Emails should come from your name and pass the checks at Gmail, Outlook and Yandex. Add three DNS records — we have generated a DKIM key for you.',
    'Письмо не найдено': 'Email not found',
    'Письмо не найдено в этом пространстве': 'Email not found in this workspace',
    'Плательщик:': 'Payer:',
    'По почтовикам': 'By mailbox provider',
    'Погружаемся…': 'Diving in…',
    'Погружение': 'Deep dive',
    'Погружение не завершено': 'The deep dive is not finished',
    'Погружение письма': 'Email deep dive',
    'Подавление сильнее согласия: новое «согласен» его не снимает. Снять может только человек — в разделе': 'Suppression outranks consent: a new “agreed” does not remove it. Only a person can lift it — in the',
    'Подавления': 'Suppressions',
    'Подавления адреса остаются — это минимальное доказательство отказа, чтобы повторный импорт не вернул адрес в рассылки. Журнал доставки писем живёт по своему сроку хранения.': 'Address suppressions remain — they are the minimal proof of refusal, so a repeated import does not put the address back into campaigns. The delivery log is kept for its retention period.',
    'Подавлено': 'Suppressed',
    'Подпись': 'Label',
    'Подробности счёта видят владелец и администраторы пространства.': 'Invoice details are visible to the workspace owner and admins.',
    'Подтверждён': 'Confirmed',
    'Подтверждённые домены': 'Verified domains',
    'Подытог': 'Subtotal',
    'Позиция': 'Item',
    'Поиск — по точному адресу, его началу (от 3 символов) или external_id.': 'Search by exact address, its beginning (from 3 characters) or external_id.',
    'Пока ни одного домена': 'No domains yet',
    'Пока тихо': 'All quiet for now',
    'Показано {a} из {b}.': 'Showing {a} of {b}.',
    'Показать раньше': 'Show earlier',
    'Получатель, тема или msg_…': 'Recipient, subject or msg_…',
    'Получить API-ключ': 'Get an API key',
    'Понял вопрос так:': 'I understood the question as:',
    'Попробуйте изменить фильтры или отправьте письмо через API.': 'Try changing the filters or send an email through the API.',
    'Последнее событие': 'Last event',
    'Последнее событие:': 'Last event:',
    'Последние 14 дней в океане {name}.': 'The last 14 days in the ocean of {name}.',
    'Последние письма': 'Recent emails',
    'Последняя проверка: {when}': 'Last check: {when}',
    'Поток': 'Stream',
    'Почтовик': 'Mail provider',
    'Почтовик, период и тип проблемы распознаются в вопросе. Без периода смотрим последние 7 дней, максимум — 30. Данные других рабочих пространств не участвуют.': 'The provider, period and type of problem are recognised from the question. Without a period we look at the last 7 days, 30 at most. Data from other workspaces is not used.',
    'Права': 'Permissions',
    'Править HTML и текст': 'Edit HTML and text',
    'Превышение не блокирует отправку.': 'Going over the limit does not block sending.',
    'Предпросмотр': 'Preview',
    'Предпросмотр письма': 'Email preview',
    'Префикс mo_live_ или mo_test_ помогает не перепутать окружения': 'The mo_live_ or mo_test_ prefix helps tell environments apart',
    'Прилив месяца': 'Monthly tide',
    'Прилив писем': 'Email tide',
    'Принято': 'Accepted',
    'Принято провайдером': 'Accepted by the provider',
    'Провайдер': 'Provider',
    'Проверен': 'Checked',
    'Проверить DNS': 'Check DNS',
    'Проверьте адрес сайта': 'Check the website address',
    'Проверьте поля формы': 'Check the form fields',
    'Проверяем…': 'Checking…',
    'Продолжить': 'Continue',
    'Продукт': 'Product',
    'Пропустить': 'Skip',
    'Пропустить и открыть бэкофис': 'Skip and open the back office',
    'Просрочен': 'Overdue',
    'Профиль': 'Profile',
    'Профиль компании': 'Company profile',
    'Профиль сохранён': 'Profile saved',
    'Публикация': 'Publishing',
    'Путь каждого письма с точностью до миллисекунды': 'The path of every email, down to the millisecond',
    'Работает после публикации. Idempotency-Key — по одному на событие (заказ, запрос сброса): повтор запроса не создаст второе письмо.': 'Works after publishing. Use one Idempotency-Key per event (an order, a password reset request): a repeated request will not create a second email.',
    'Рабочий email': 'Work email',
    'Раздельные потоки: отписка от рассылок не блокирует сброс пароля': 'Separate streams: unsubscribing from campaigns does not block password resets',
    'Режим': 'Mode',
    'Режим песочницы: письмо проходит весь путь внутри MailOcean, но наружу не уходит.': 'Sandbox mode: the email goes through the whole path inside MailOcean but is not sent outside.',
    'Реквизиты для оплаты': 'Payment details',
    'Риф: ключ для вашего кода': 'Reef: a key for your code',
    'Роль «наблюдатель» может смотреть черновики, но не создавать их.': 'The viewer role can look at drafts but cannot create them.',
    'Русский': 'Russian',
    'С': 'From',
    'С возвращением на борт': 'Welcome back aboard',
    'Сайт': 'Website',
    'Светлая': 'Light',
    'Сгенерировать черновик': 'Generate draft',
    'Сгенерируйте первый — он появится здесь.': 'Generate the first one — it will appear here.',
    'Сегмент': 'Segment',
    'Секрет подписи (показывается один раз)': 'Signing secret (shown once)',
    'Сеть недоступна. Попробуйте ещё раз.': 'Network unavailable. Please try again.',
    'Скачать CSV': 'Download CSV',
    'Скопировать реквизиты': 'Copy details',
    'Скопируйте ключ сейчас — после обновления страницы он больше не будет показан.': 'Copy the key now — it will not be shown again after the page is refreshed.',
    'Скрытая копия': 'Bcc',
    'Слишком много попыток. Подождите минуту.': 'Too many attempts. Wait a minute.',
    'Смена тарифа — это заявка менеджеру: он подтвердит условия и выставит счёт. Деньги автоматически не списываются.': 'A plan change is a request to the manager: they will confirm the terms and issue an invoice. Money is not charged automatically.',
    'Сменить тариф': 'Change plan',
    'Собираем черновик…': 'Building the draft…',
    'Событий нет. Их передают через': 'No events. They are sent via',
    'Событий пока нет': 'No events yet',
    'События': 'Events',
    'Совет: используйте поддомен, например mail.вашсайт.com — так репутация рассылок не смешивается с основным доменом': 'Tip: use a subdomain, for example mail.yoursite.com — this keeps campaign reputation separate from your main domain',
    'Согласие': 'Consent',
    'Согласие на маркетинг': 'Marketing consent',
    'Согласие на маркетинг здесь не ставится: его записывают с источником и доказательством в карточке контакта или через API.': 'Marketing consent is not set here: it is recorded with its source and proof on the contact card or through the API.',
    'Содержимое удалено после отправки — храним только метаданные': 'Content was deleted after sending — we keep only the metadata',
    'Создайте ключ, чтобы отправлять письма из своего кода.': 'Create a key to send emails from your code.',
    'Создан': 'Created',
    'Создать': 'Create',
    'Создать аккаунт': 'Create account',
    'Создать вебхук': 'Create webhook',
    'Создать ключ': 'Create key',
    'Состояние моря': 'Sea state',
    'Сотрудник MailOcean': 'MailOcean staff',
    'Сохраните ключ в менеджере секретов или переменной окружения MAILOCEAN_API_KEY. После закрытия шага он скрывается навсегда.': 'Save the key in your secrets manager or in the MAILOCEAN_API_KEY environment variable. It will be hidden for good once you close this step.',
    'Сохранить': 'Save',
    'Спросите словами. Ответ собирается из событий ваших писем, кодов SMTP, подавлений и проверки DNS — каждый вывод ссылается на события, письма или проверку DNS.': 'Ask in plain words. The answer is built from your email events, SMTP codes, suppressions and DNS checks — every conclusion links to the events, emails or DNS check it is based on.',
    'Спросить': 'Ask',
    'Срок оплаты': 'Payment due',
    'Статус': 'Status',
    'Сумма': 'Amount',
    'Схема атрибутов': 'Attribute schema',
    'Сценарии': 'Journeys',
    'Счета': 'Invoices',
    'Счета, суммы и реквизиты для оплаты видят владелец и администраторы пространства.': 'Invoices, amounts and payment details are visible to the workspace owner and admins.',
    'Счетов пока нет': 'No invoices yet',
    'Считаются письма, принятые провайдером. Тестовые письма мастера онбординга ({n}) в объём не входят.': 'Emails accepted by the provider are counted. Test emails from the onboarding wizard ({n}) are not included in the volume.',
    'Счёт': 'Invoice',
    'Счёт выставляется вручную, оплата не списывается автоматически. Единица учёта — письмо, принятое провайдером (не получатель).': 'Invoices are issued manually and payment is not charged automatically. The unit of billing is an email accepted by the provider (not a recipient).',
    'Счёт не найден.': 'Invoice not found.',
    'Также подавить адрес для маркетинга': 'Also suppress the address for marketing',
    'Также подходит: {list}': 'Also fits: {list}',
    'Таких событий нет': 'No such events',
    'Такой алиас уже занят — выберите «новая версия» или смените алиас': 'This alias is already taken — choose “new version” or change the alias',
    'Такой контакт уже был — обновили': 'This contact already existed — updated',
    'Тариф': 'Plan',
    'Тариф и оплата': 'Plan and billing',
    'Тариф не назначен — напишите менеджеру.': 'No plan assigned — contact the manager.',
    'Теги и метаданные': 'Tags and metadata',
    'Текст': 'Text',
    'Тема': 'Subject',
    'Тема · отправитель': 'Subject · sender',
    'Тема:': 'Subject:',
    'Тестовый': 'Test',
    'Тип': 'Type',
    'Тип письма': 'Email type',
    'Тихой ночи': 'Quiet night',
    'Только https и публичный адрес': 'HTTPS and a public address only',
    'Топ за 7 дней': 'Top for 7 days',
    'Транзакционные': 'Transactional',
    'Транзакционные письма для продуктов, которым нельзя терять ни одного чека, кода или подтверждения.': 'Transactional email for products that cannot afford to lose a single receipt, code or confirmation.',
    'Транзакционные письма согласия не требуют. Нет записи — маркетинг не отправляется. Действует самая поздняя по времени запись.': 'Transactional emails do not require consent. No record — no marketing is sent. The most recent record applies.',
    'Транзакционный': 'Transactional',
    'Тёмная': 'Dark',
    'Удалить {key}': 'Delete {key}',
    'Удалить атрибут {key}?': 'Delete attribute {key}?',
    'Удалить домен {name}? Отправка с него сразу прекратится.': 'Delete domain {name}? Sending from it will stop immediately.',
    'Удалить навсегда': 'Delete permanently',
    'Удалить по GDPR': 'Delete under GDPR',
    'Удалить черновик': 'Delete draft',
    'Удалить черновик? Опубликованные из него шаблоны останутся.': 'Delete the draft? Templates already published from it will remain.',
    'Удалятся контакт, его атрибуты, события, согласия и членство в сегментах. Отменить нельзя.': 'The contact, its attributes, events, consents and segment memberships will be deleted. This cannot be undone.',
    'Уже есть аккаунт?': 'Already have an account?',
    'Уже опубликован: v{v} ·': 'Already published: v{v} ·',
    'Устно по телефону 11.10, звонок №1234': 'Verbally by phone on 11.10, call no. 1234',
    'Устройство не поддерживает passkeys или вход отменён.': 'This device does not support passkeys, or sign-in was cancelled.',
    'ФИНИШ': 'FINISH',
    'Цвет бренда': 'Brand colour',
    'Цена': 'Price',
    'Часовой пояс:': 'Time zone:',
    'Черновики': 'Drafts',
    'Черновиков пока нет': 'No drafts yet',
    'Что': 'What',
    'Что будете отправлять?': 'What will you send?',
    'Что делают ваши контакты: заказы, корзины, входы. По событиям строятся сегменты и сценарии. Повтор с тем же': 'What your contacts do: orders, carts, sign-ins. Segments and journeys are built from events. A repeat with the same',
    'ШАГ {n} ИЗ 5': 'STEP {n} OF 5',
    'Шаблон': 'Template',
    'Шельф: ваш домен отправки': 'Shelf: your sending domain',
    'Эмуляция почтового клиента в тёмной теме (Apple Mail, iOS, Outlook.com). Gmail тёмные правила игнорирует и показывает светлую версию — она тоже читаемая.': 'Emulation of a mail client in dark mode (Apple Mail, iOS, Outlook.com). Gmail ignores dark rules and shows the light version — which is readable too.',
    'Этот passkey не подошёл. Войдите паролем.': 'This passkey did not work. Sign in with your password.',
    'Я сохранил ключ': 'I saved the key',
    'Язык': 'Language',
    'адрес': 'address',
    'архетип': 'archetype',
    'архетип без AI': 'archetype without AI',
    'без ключа': 'no key',
    'бесплатно': 'free',
    'в выборке': 'in the sample',
    'в существующую. Две записи SPF делают проверку недействительной.': 'to the existing one. Two SPF records make the check fail.',
    'ваш-домен.com': 'your-domain.com',
    'версия {v}': 'version {v}',
    'волна,': 'wave,',
    'все': 'all',
    'все почтовики': 'all providers',
    'все проблемы': 'all issues',
    'вход': 'entry',
    'готово': 'done',
    'да': 'yes',
    'до {n} в день': 'up to {n} per day',
    'доменов: {n}': 'domains: {n}',
    'домены без ограничения': 'unlimited domains',
    'доставлено по событиям: {n}': 'delivered per events: {n}',
    'журнал {n} дн.': 'log {n} d.',
    'за 14 дней': 'over 14 days',
    'записал: {who}': 'recorded by: {who}',
    'записано {date}': 'recorded {date}',
    'значение': 'value',
    'и покажем его путь по шагам.': 'and show its path step by step.',
    'из {included} · {pct}%': 'of {included} · {pct}%',
    'ключ': 'key',
    'контакт': 'contact',
    'контрольная группа': 'control group',
    'которая доходит до берега.': 'that reaches the shore.',
    'медиана {v}': 'median {v}',
    'найдено': 'found',
    'не облагается в v1': 'not subject to VAT in v1',
    'не отправлялись': 'not sent',
    'не повторяются сами': 'not retried automatically',
    'не проверено': 'not checked',
    'не совпадает': 'does not match',
    'не создаёт второе событие.': 'will not create a second event.',
    'нет': 'no',
    'нет записи': 'no record',
    'новую версию шаблона «{name}» (v{v}). Письма по алиасу «{alias}» сразу начнут уходить в новом виде.': 'a new version of the template «{name}» (v{v}). Emails sent under the alias «{alias}» will switch to it immediately.',
    'новый шаблон «{name}» с алиасом «{alias}».': 'a new template «{name}» with the alias «{alias}».',
    'норма < 0,1%': 'target < 0.1%',
    'норма < 2%': 'target < 2%',
    'обязательно': 'required',
    'оплачен {date}': 'paid {date}',
    'опубликован v{v}': 'published v{v}',
    'от': 'from',
    'от переданных': 'of handed-off',
    'отзыв': 'withdrawal',
    'открыть шаблон': 'open template',
    'отозван': 'revoked',
    'по домену получателя и MX': 'by recipient domain and MX',
    'подтверждён {when}': 'verified {when}',
    'позже': 'later',
    'показаны последние 20 000': 'showing the latest 20,000',
    'последние 50': 'last 50',
    'пояс пространства': 'workspace time zone',
    'принято {d}': 'received {d}',
    'проблемы': 'issues',
    'рекомендуется': 'recommended',
    'с адреса': 'from',
    'сверх лимита {sum} / 1 000': 'over the limit {sum} / 1,000',
    'система': 'system',
    'согласие': 'consent',
    'текст: {model}': 'text: {model}',
    'текущий': 'current',
    'удалено': 'deleted',
    'участия контакта': 'contact’s participations',
    'черновик': 'draft',
    'шаг {n}': 'step {n}',
    '— без адреса —': '— no address —',
    '— не по теме вопроса': '— not related to the question',
    '⚡ транз.': '⚡ transact.',
    '🌊 маркет.': '🌊 marketing',
    // Non-literal labels (maps and constants translated at render time)
    'Отправка писем': 'Sending emails',
    'Чтение писем и статусов': 'Reading emails and statuses',
    'Изменение подавлений': 'Changing suppressions',
    'Чтение подавлений': 'Reading suppressions',
    'Чтение контактов, событий и сегментов': 'Reading contacts, events and segments',
    'Изменение контактов и сегментов, удаление по GDPR': 'Changing contacts and segments, GDPR deletion',
    'Передача событий': 'Sending events',
    'Чтение сценариев, статистики и отчётов; симуляции нужен и contacts:read': 'Reading journeys, statistics and reports; simulation also needs contacts:read',
    'Сценарии как код: версии, запрос согласования, публикация согласованного, пауза, зачисление': 'Journeys as code: versions, approval requests, publishing the approved version, pausing, enrolment',
    'Вход': 'Sign-in',
    'Вход с 2FA': 'Sign-in with 2FA',
    'Вход по коду восстановления': 'Sign-in with a recovery code',
    'Сброс пароля': 'Password reset',
    'Создан API-ключ': 'API key created',
    'Отозван API-ключ': 'API key revoked',
    'Добавлен домен': 'Domain added',
    'Проверка DNS': 'DNS check',
    'Удалён домен': 'Domain deleted',
    'Тестовое письмо': 'Test email',
    'Адрес в подавлениях': 'Address on the suppression list',
    'Адрес убран из подавлений': 'Address removed from suppressions',
    'Создан вебхук': 'Webhook created',
    'Удалён вебхук': 'Webhook deleted',
    'Ping вебхука': 'Webhook ping',
    'Приглашение': 'Invitation',
    'Приглашение отозвано': 'Invitation revoked',
    'Приглашение принято': 'Invitation accepted',
    'Смена роли': 'Role change',
    'Участник удалён': 'Member removed',
    'Создан шаблон': 'Template created',
    'Новая версия шаблона': 'New template version',
    'Удалён шаблон': 'Template deleted',
    'Настройки пространства': 'Workspace settings',
    'Новое пространство': 'New workspace',
    'Онбординг завершён': 'Onboarding completed',
    '2FA включён': '2FA enabled',
    '2FA выключен': '2FA disabled',
    'Новые коды восстановления': 'New recovery codes',
    'Добавлен passkey': 'Passkey added',
    'Удалён passkey': 'Passkey removed',
    'Вход с passkey': 'Sign-in with passkey',
    'Экспорт журнала': 'Log export',
    'Подтвердить домен': 'Verify domain',
    'Создать API-ключ': 'Create API key',
    'Отправить первое письмо': 'Send first email',
    'Подключить вебхук': 'Connect webhook',
    'Пробный период': 'Trial period',
    'Активен': 'Active',
    'Есть просроченный счёт': 'Overdue invoice',
    'Завершён': 'Ended',
    'после подтверждения домена': 'after domain verification',
    'выделенный IP': 'dedicated IP',
    'SLA': 'SLA',
    'строка': 'string',
    'число': 'number',
    'да / нет': 'yes / no',
    'дата': 'date',
    'дата и время': 'date and time',
    'список строк': 'list of strings',
    'жёсткий отскок': 'hard bounce',
    'жалоба на спам': 'spam complaint',
    'отписка': 'unsubscribe',
    'вручную': 'manually',
    'ящик переполнен 3 раза за 30 дней': 'mailbox full 3 times in 30 days',
    'маркетинг': 'marketing',
    'Почему падают письма на Apple?': 'Why are emails to Apple failing?',
    'Жалобы на спам в Gmail за неделю': 'Spam complaints at Gmail this week',
    'Что с письмами с неизвестным исходом?': 'What about emails with an unknown outcome?',
    'Почему письма уходят в спам у Яндекса?': 'Why do emails go to spam at Yandex?',
    'Hard bounce на mail.ru за 3 дня': 'Hard bounce at mail.ru over 3 days',
    'Критично': 'Critical',
    'Внимание': 'Warning',
    'К сведению': 'For your information',
    'отказы': 'bounces',
    'SPF / DKIM / DMARC': 'SPF / DKIM / DMARC',
    'письмо': 'email',
    'событие': 'event',
    'домен': 'domain',
    'подавление': 'suppressed',
    'outbox': 'outbox',
    'В очереди': 'Queued',
    'Передано': 'Handed over',
    'Доставлено': 'Delivered',
    'Отскок': 'Bounced',
    'Жалоба': 'Complaint',
    'Ошибка': 'Error',
    'Неизвестно': 'Unknown',
    'Отменено MailOcean': 'Cancelled by MailOcean',
    'Принято API, ждёт передачи провайдеру': 'Accepted by the API, waiting to be handed to the provider',
    'Провайдер принял письмо': 'The provider accepted the email',
    'Почтовый сервер получателя подтвердил приём': 'The recipient\'s mail server confirmed receipt',
    'Постоянный отказ сервера получателя': 'Permanent refusal by the recipient\'s server',
    'Получатель отметил письмо как спам — добавлен в подавления': 'The recipient marked the email as spam — added to suppressions',
    'Провайдер окончательно отклонил письмо': 'The provider permanently rejected the email',
    'Результат передачи неизвестен; повторно не отправляем, чтобы не создать дубль': 'The delivery result is unknown; we do not resend, to avoid a duplicate',
    'Адрес в списке подавлений — письмо не отправлялось': 'The address is in the suppression list — the email was not sent',
    'Отменено сотрудником MailOcean до передачи провайдеру — письмо не отправлялось': 'Cancelled by a MailOcean employee before handover to the provider — the email was not sent',
    'Поверхность': 'Surface',
    'Шельф': 'Shelf',
    'Риф': 'Reef',
    'Глубина': 'Deep',
    'Бездна': 'Abyss',
    'Впадина': 'Trench',
    'Компания и цели': 'Company and goals',
    'SPF, DKIM, DMARC': 'SPF, DKIM, DMARC',
    'Доступ для кода': 'Access for code',
    'Живой путь в мс': 'Live path in ms',
    'События в ваш сервер': 'Events to your server',
    'Готово': 'Done',
    '0 м': '0 m',
    '50 м': '50 m',
    '200 м': '200 m',
    '1 000 м': '1,000 m',
    '4 000 м': '4,000 m',
    '11 000 м': '11,000 m',
    '⚡ Транзакционные': '⚡ Transactional',
    '🌊 Маркетинговые': '🌊 Marketing',
    '🐋 И то, и другое': '🐋 Both',
    'Чеки, коды, сброс пароля, уведомления': 'Receipts, codes, password reset, notifications',
    'Рассылки, акции, цепочки': 'Campaigns, promotions, sequences',
    'Раздельные потоки в одном аккаунте': 'Separate streams in one account',
    'до 10 тыс.': 'up to 10k',
    '10–100 тыс.': '10–100k',
    '100 тыс. – 1 млн': '100k – 1M',
    'больше 1 млн': 'over 1M',
  },
  uk: {
    ' · пробный период до {date}': ' · пробний період до {date}',
    ', последний пересчёт — {time}': ', останній перерахунок — {time}',
    '// Без idempotencyKey SDK сам ставит ключ — повтор при сбое сети не создаст второе событие.': '// Без idempotencyKey SDK сам ставить ключ: повтор після збою мережі не створить другу подію.',
    '// Проверка подписи (Node.js)': '// Перевірка підпису (Node.js)',
    '11 000 метров — глубже только ваши метрики. Аккаунт готов принимать трафик.': '11 000 метрів — глибше лише ваші метрики. Обліковий запис готовий приймати трафік.',
    'AI': 'AI',
    'AI-доработка выключена: не задан ANTHROPIC_API_KEY': 'AI-доопрацювання вимкнено: не задано ANTHROPIC_API_KEY',
    'AI-доработка текста (выключена)': 'AI-доопрацювання тексту (вимкнено)',
    'AI-доработка текста: {model}': 'AI-доопрацювання тексту: {model}',
    'AI-пересказ выключен': 'AI-переказ вимкнено',
    'AI-пересказ: {model}': 'AI-переказ: {model}',
    'API-ключ': 'API-ключ',
    'API-ключ даёт серверу право отправлять письма. Мы храним только его хеш — показать ключ повторно не сможем.': 'API-ключ дає серверу право надсилати листи. Ми зберігаємо лише його хеш, тож показати ключ повторно не зможемо.',
    'API-ключи': 'API-ключі',
    'Backend production': 'Backend production',
    'Email, начало адреса или external_id': 'Email, початок адреси або external_id',
    'Hard bounce': 'Hard bounce',
    'MailOcean не меняет DNS сам: добавьте запись у вашего DNS-провайдера и нажмите «Проверить DNS» на странице домена.': 'MailOcean сам не змінює DNS: додайте запис у вашого DNS-провайдера і натисніть «Перевірити DNS» на сторінці домену.',
    'MailOcean сообщит вашему бэкенду о доставке, отскоках и жалобах. Каждый запрос подписан HMAC-SHA256.': 'MailOcean повідомлятиме ваш бекенд про доставку, відскоки та скарги. Кожен запит підписано HMAC-SHA256.',
    'URL эндпоинта': 'URL ендпоінта',
    'hello@ваш-домен.com': 'hello@ваш-домен.com',
    'id пользователя в вашей системе; нужен email или external_id': 'ID користувача у вашій системі; потрібен email або external_id',
    'v{v} · {where} · {when}': 'v{v} · {where} · {when}',
    '{a} из {b} ключей': '{a} з {b} ключів',
    '{base} (может быть, {guess}?)': '{base} (можливо, {guess}?)',
    '{n} писем в месяц': '{n} листів на місяць',
    '{n} событий': '{n} подій',
    '{scope} ({reason})': '{scope} ({reason})',
    '{sum} / мес.': '{sum} / міс.',
    'Адрес в подавлениях: {list}.': 'Адресу в списку придушення: {list}.',
    'Аккаунт и рабочее пространство за минуту.': 'Обліковий запис і робочий простір за хвилину.',
    'Аккаунт с этим email уже существует': 'Обліковий запис із цим email уже існує',
    'Алиас': 'Аліас',
    'Атрибутов нет.': 'Атрибутів немає.',
    'Атрибуты': 'Атрибути',
    'Атрибуты (JSON)': 'Атрибути (JSON)',
    'Атрибуты — JSON-объект, например { "plan": "pro" }': 'Атрибути — це JSON-об’єкт, наприклад { "plan": "pro" }',
    'Без AI: готовые архетипы': 'Без AI: готові архетипи',
    'Бездна: события в ваш сервер': 'Безодня: події на ваш сервер',
    'Боевой': 'Бойовий',
    'Ваше имя': 'Ваше ім’я',
    'Введите {what} для подтверждения': 'Введіть {what} для підтвердження',
    'Вебхук создан: {url}': 'Вебхук створено: {url}',
    'Вебхуки': 'Вебхуки',
    'Вложения': 'Вкладення',
    'Возможно, он удалён по запросу субъекта данных.': 'Можливо, його видалено за запитом суб’єкта даних.',
    'Войдите, чтобы продолжить.': 'Увійдіть, щоб продовжити.',
    'Войти': 'Увійти',
    'Войти с passkey': 'Увійти з passkey',
    'Вопрос': 'Питання',
    'Впервые здесь?': 'Вперше тут?',
    'Все': 'Усі',
    'Все домены': 'Усі домени',
    'Все контакты': 'Усі контакти',
    'Все письма': 'Усі листи',
    'Все потоки': 'Усі потоки',
    'Все шаблоны': 'Усі шаблони',
    'Вы в океане': 'Ви в океані',
    'Вы превысили включённый объём. Письма продолжают отправляться; разница войдёт в следующий счёт.': 'Ви перевищили включений обсяг. Листи надалі надсилаються; різницю буде додано до наступного рахунку.',
    'Выставлен: {date}': 'Виставлено: {date}',
    'ГЛУБИНА {d}': 'ГЛИБИНА {d}',
    'Глубже': 'Глибше',
    'Глубина: первое письмо': 'Глибина: перший лист',
    'Готово, я сохранил': 'Готово, я зберіг',
    'Дальше': 'Далі',
    'Действие': 'Дія',
    'Детали': 'Деталі',
    'Детектив логов': 'Детектив логів',
    'Добавить': 'Додати',
    'Добавить домен': 'Додати домен',
    'Добавлен': 'Додано',
    'Добавлен:': 'Додано:',
    'Добавьте домен, чтобы письма приходили от вашего имени и проходили SPF и DKIM.': 'Додайте домен, щоб листи надходили від вашого імені та проходили SPF і DKIM.',
    'Добавьте их у вашего DNS-провайдера': 'Додайте їх у вашого DNS-провайдера',
    'Добро пожаловать на поверхность, {name} 👋': 'Ласкаво просимо на поверхню, {name} 👋',
    'Доброе утро': 'Доброго ранку',
    'Добрый вечер': 'Добрий вечір',
    'Добрый день': 'Добрий день',
    'Доказательство': 'Доказ',
    'Домен': 'Домен',
    'Домен {name}': 'Домен {name}',
    'Домен отправки': 'Домен відправлення',
    'Домен подтверждён 🌊': 'Домен підтверджено 🌊',
    'Домен подтверждён. Письма будут подписаны DKIM и пройдут SPF.': 'Домен підтверджено. Листи підписуватимуться DKIM і проходитимуть SPF.',
    'Домен удалён': 'Домен видалено',
    'Домены': 'Домени',
    'Домены, от имени которых вы отправляете письма. Подтверждённый домен подписывает каждое письмо DKIM.': 'Домени, від імені яких ви надсилаєте листи. Підтверджений домен підписує кожен лист DKIM.',
    'Доработать текст моделью': 'Доопрацювати текст моделлю',
    'Доработать текст моделью (вёрстка, ссылки и переменные не меняются)': 'Доопрацювати текст моделлю (верстка, посилання та змінні не змінюються)',
    'Другие проблемы за период': 'Інші проблеми за період',
    'Если у домена уже есть SPF-запись, не создавайте вторую — добавьте': 'Якщо в домені вже є SPF-запис, не створюйте другий — додайте',
    'Есть': 'Є',
    'Ещё один шаг': 'Ще один крок',
    'Жалобы': 'Скарги',
    'Ждём DNS': 'Очікуємо DNS',
    'Журнал действий': 'Журнал дій',
    'За неделю событий не было.': 'За тиждень подій не було.',
    'Забыли пароль?': 'Забули пароль?',
    'Загружаем…': 'Завантажуємо…',
    'Загружаю…': 'Завантажую…',
    'Загрузить ещё': 'Завантажити ще',
    'Задайте вопрос о доставке': 'Поставте питання про доставку',
    'Задержка p95': 'Затримка p95',
    'Записано': 'Записано',
    'Записать': 'Записати',
    'Записей не найдено': 'Записів не знайдено',
    'Записей нет.': 'Записів немає.',
    'Записи пока не найдены': 'Записів поки не знайдено',
    'Запись': 'Запис',
    'Запись о согласии': 'Запис про згоду',
    'Здесь появится путь письма: приём API → очередь → передача провайдеру → ответ провайдера.': 'Тут з’явиться шлях листа: прийом API → черга → передача провайдеру → відповідь провайдера.',
    'Здесь появятся действия команды и API-ключей.': 'Тут з’являтимуться дії команди та API-ключів.',
    'Здоровье падает от отскоков, жалоб, ошибок и отсутствия подтверждённого домена — тех же сигналов, по которым почтовики решают, куда класть письма.': 'Стан здоров’я знижують відскоки, скарги, помилки та відсутність підтвердженого домену — ті самі сигнали, за якими поштові сервіси вирішують, куди класти листи.',
    'Значение': 'Значення',
    'Идемпотентный API: повтор запроса не создаёт дубль': 'Ідемпотентний API: повторний запит не створює дубль',
    'Изменения DNS обычно применяются за 5–30 минут, иногда до 48 часов. Можно продолжить: первое тестовое письмо мы отправим с домена {domain}.': 'Зміни DNS зазвичай застосовуються за 5–30 хвилин, інколи до 48 годин. Можна продовжити: перший тестовий лист ми надішлемо з домену {domain}.',
    'Изменён:': 'Змінено:',
    'Имя (host)': 'Ім’я (host)',
    'Имя в шапке и подписи': 'Відображається в шапці та підписі',
    'Использован': 'Використано',
    'Использовано писем за месяц': 'Листів використано за місяць',
    'Источник': 'Джерело',
    'Источник: {source}': 'Джерело: {source}',
    'Исход неизвестен': 'Результат невідомий',
    'Итого': 'Разом',
    'К оплате': 'До сплати',
    'Каждое письмо и его путь — от приёма API до ответа почтового сервера.': 'Кожен лист і його шлях — від прийому API до відповіді поштового сервера.',
    'Каждое письмо — ': 'Кожен лист — це ',
    'Как в описании': 'Як в описі',
    'Как оплатить': 'Як оплатити',
    'Как передать событие': 'Як передати подію',
    'Как получено': 'Як отримано',
    'Какое письмо нужно': 'Який лист потрібен',
    'Ключ': 'Ключ',
    'Ключ «{name}» создан': 'Ключ «{name}» створено',
    'Ключ атрибута': 'Ключ атрибута',
    'Ключ объявлен': 'Ключ оголошено',
    'Ключ отозван': 'Ключ відкликано',
    'Ключ уже создан. Новые ключи — в разделе «API-ключи» бэкофиса.': 'Ключ уже створено. Нові ключі — у розділі «API-ключі» бекофісу.',
    'Ключей пока нет': 'Ключів поки немає',
    'Ключи для серверов. Храним только хеш: потерянный ключ не восстановить — отзовите и создайте новый.': 'Ключі для серверів. Ми зберігаємо лише хеш: загублений ключ не відновити — відкличте його і створіть новий.',
    'Ключи появятся с первыми контактами. Строка, похожая на дату, остаётся строкой — дату объявите заранее.': 'Ключі з’являться з першими контактами. Рядок, схожий на дату, залишається рядком — дату оголосіть наперед.',
    'Кнопки и ссылки; контраст текста подбирается сам': 'Кнопки та посилання; контраст тексту підбирається автоматично',
    'Когда': 'Коли',
    'Кол-во': 'Кількість',
    'Комментарий для менеджера': 'Коментар для менеджера',
    'Компания': 'Компанія',
    'Кому': 'Кому',
    'Контакт': 'Контакт',
    'Контакт добавлен': 'Контакт додано',
    'Контакт не найден': 'Контакт не знайдено',
    'Контакт не участвовал в сценариях.': 'Контакт не брав участі в сценаріях.',
    'Контакт удалён. Квитанция без персональных данных сохранена.': 'Контакт видалено. Квитанцію без персональних даних збережено.',
    'Контактов пока нет': 'Контактів поки немає',
    'Контакты': 'Контакти',
    'Копировать значение': 'Копіювати значення',
    'Копия': 'Копія',
    'Кто': 'Хто',
    'Кто, что и когда изменил: люди и API-ключи. Пароли, токены и секреты сюда не попадают.': 'Хто, що і коли змінив: люди та API-ключі. Паролі, токени й секрети сюди не потрапляють.',
    'Куда': 'Куди',
    'Локаль:': 'Локаль:',
    'Лучше поддомен, например mail.example.com': 'Краще піддомен, наприклад mail.example.com',
    'Люди, которым вы пишете: идентификаторы, атрибуты, согласие на маркетинг и события. Профили не склеиваются сами — конфликт идентификаторов возвращается ошибкой.': 'Люди, яким ви пишете: ідентифікатори, атрибути, згода на маркетинг і події. Профілі не зливаються самі: конфлікт ідентифікаторів повертає помилку.',
    'Маркетинг': 'Маркетинг',
    'Маркетинговые': 'Маркетингові',
    'Маркетинговый': 'Маркетинговий',
    'Минимально необходимые права уменьшают ущерб при утечке': 'Мінімально потрібні права зменшують збитки у разі витоку',
    'Минимум 10 символов': 'Щонайменше 10 символів',
    'Модель только пересказывает найденные факты': 'Модель лише переказує знайдені факти',
    'НДС': 'ПДВ',
    'На бесплатном тарифе счета не выставляются. После смены тарифа менеджер пришлёт счёт — он появится здесь.': 'На безкоштовному тарифі рахунки не виставляються. Після зміни тарифу менеджер надішле рахунок — він з’явиться тут.',
    'На дно': 'На дно',
    'Назад': 'Назад',
    'Название': 'Назва',
    'Название ключа': 'Назва ключа',
    'Например: «Backend production» или «Staging»': 'Наприклад: «Backend production» або «Staging»',
    'Например: «код подтверждения входа, живёт 10 минут» или «receipt after payment»': 'Наприклад: «код підтвердження входу, дійсний 10 хвилин» або «receipt after payment»',
    'Например: почему падают письма на Apple? или msg_… — что с этим письмом?': 'Наприклад: чому не доходять листи на Apple? Або msg_… — що з цим листом?',
    'Настрою позже': 'Налаштую пізніше',
    'Начало периода': 'Початок періоду',
    'Начало периода (необязательно)': 'Початок періоду (необов’язково)',
    'Начать погружение': 'Почати занурення',
    'Не отправлено подавленным адресам: {list}': 'Не надіслано адресам зі списку придушення: {list}',
    'Не получилось отправить заявку': 'Не вдалося надіслати запит',
    'Не удалось загрузить данные о тарифе: {msg}': 'Не вдалося завантажити дані про тариф: {msg}',
    'Не хватает переменных: {list}': 'Бракує змінних: {list}',
    'Неверный email или пароль': 'Невірний email або пароль',
    'Необязательно: ожидаемый объём, реквизиты компании, удобное время для связи': 'Необов’язково: очікуваний обсяг, реквізити компанії, зручний час для зв’язку',
    'Нет': 'Ні',
    'Нет HTML-версии': 'Немає HTML-версії',
    'Нет записи о согласии — маркетинг не отправляется': 'Немає запису про згоду — маркетингові листи не надсилаються',
    'Нет текстовой версии': 'Немає текстової версії',
    'Никого не нашли': 'Нікого не знайдено',
    'Ничего не найдено': 'Нічого не знайдено',
    'Новая версия существующего шаблона сразу начнёт использоваться при отправке по его алиасу': 'Нова версія наявного шаблону одразу почне використовуватися під час надсилання за його аліасом',
    'Новая версия: {name} ({alias}, сейчас v{v})': 'Нова версія: {name} ({alias}, зараз v{v})',
    'Новый API-ключ': 'Новий API-ключ',
    'Новый домен': 'Новий домен',
    'Новый ключ': 'Новий ключ',
    'Новый ключ получает тип по первому значению': 'Новий ключ отримує тип за першим значенням',
    'Новый контакт': 'Новий контакт',
    'Новый шаблон (v1)': 'Новий шаблон (v1)',
    'Номер': 'Номер',
    'Нужен, чтобы подсказать домен отправки': 'Потрібен, щоб запропонувати домен відправлення',
    'Нырнуть глубже': 'Зануритися глибше',
    'Ныряем…': 'Занурюємося…',
    'Обновить': 'Оновити',
    'Обновляется каждые 15 минут': 'Оновлюється щоп’ятнадцять хвилин',
    'Объект': 'Об’єкт',
    'Объявить': 'Оголосити',
    'Объём в месяц': 'Обсяг на місяць',
    'Обязательно: это доказательство на случай проверки': 'Обов’язково: це доказ на випадок перевірки',
    'Океан пока спокоен': 'Океан поки спокійний',
    'Опишите письмо словами — получите черновик шаблона: светлая и тёмная тема, текстовая версия, переменные и код отправки. Черновик ничего не отправляет: шаблоном он станет только после публикации.': 'Опишіть лист словами — отримайте чернетку шаблону: світла й темна теми, текстова версія, змінні та код надсилання. Чернетка нічого не надсилає: шаблоном вона стане лише після публікації.',
    'Оплата фиксируется вручную после поступления перевода. Автоматического списания нет.': 'Оплата фіксується вручну після надходження переказу. Автоматичного списання немає.',
    'Оплатить до: {date}': 'Сплатити до: {date}',
    'Оплату отмечает финансовый отдел MailOcean после поступления перевода — обычно в течение рабочего дня.': 'Фінансовий відділ MailOcean позначає оплату після надходження переказу — зазвичай протягом робочого дня.',
    'Оплачено': 'Сплачено',
    'Оповещения': 'Сповіщення',
    'Определить по описанию': 'Визначити за описом',
    'Опубликовано: {alias} v{v}': 'Опубліковано: {alias} v{v}',
    'Опубликовать': 'Опублікувати',
    'Опубликовать {what}': 'Опублікувати {what}',
    'Осталось шагов: {n}. Каждый из них приближает письма к «Входящим».': 'Залишилось кроків: {n}. Кожен із них наближає листи до «Вхідних».',
    'От': 'Від',
    'Ответить': 'Відповісти на',
    'Ответы собираются без модели': 'Відповіді складаються без моделі',
    'Отзыв': 'Відкликання',
    'Открыть бэкофис': 'Відкрити бекофіс',
    'Отмена': 'Скасувати',
    'Отозвано': 'Відкликано',
    'Отозвать': 'Відкликати',
    'Отозвать ключ «{name}»? Запросы с ним сразу начнут получать 401.': 'Відкликати ключ «{name}»? Запити з ним одразу отримуватимуть 401.',
    'Отправим тестовое письмо на': 'Надішлемо тестовий лист на',
    'Отправить заявку': 'Надіслати запит',
    'Отправить себе письмо': 'Надіслати собі лист',
    'Отправка из кода': 'Надсилання з коду',
    'Отправляем…': 'Надсилаємо…',
    'Отправьте первое письмо через API — оно появится здесь через мгновение.': 'Надішліть перший лист через API — він з’явиться тут за мить.',
    'Отскоки': 'Відскоки',
    'Пара вопросов, чтобы настроить океан под ваш продукт. Это займёт меньше минуты.': 'Кілька запитань, щоб налаштувати океан під ваш продукт. Це займе менше хвилини.',
    'Пароль': 'Пароль',
    'Первая волна дошла до провайдера за {ms} мс.': 'Перша хвиля дійшла до провайдера за {ms} мс.',
    'Первое письмо': 'Перший лист',
    'Передайте их из своего приложения — одним вызовом при регистрации или оформлении заказа. Повторный вызов обновляет контакт.': 'Передайте їх зі свого застосунку одним викликом під час реєстрації або оформлення замовлення. Повторний виклик оновлює контакт.',
    'Передайте первое событие из приложения — пример справа.': 'Передайте першу подію із застосунку — приклад праворуч.',
    'Переменные:': 'Змінні:',
    'Период': 'Період',
    'Период: {from} — {to}': 'Період: {from} — {to}',
    'Печать / PDF': 'Друк / PDF',
    'Писем': 'Листів',
    'Письма': 'Листи',
    'Письма должны приходить от вашего имени и проходить проверки Gmail, Outlook и Яндекса. Добавьте три DNS-записи — мы сгенерировали для вас ключ DKIM.': 'Листи мають надходити від вашого імені та проходити перевірки Gmail, Outlook і Яндекса. Додайте три DNS-записи — ми згенерували для вас ключ DKIM.',
    'Письмо не найдено': 'Лист не знайдено',
    'Письмо не найдено в этом пространстве': 'Лист не знайдено в цьому просторі',
    'Плательщик:': 'Платник:',
    'По почтовикам': 'За поштовими сервісами',
    'Погружаемся…': 'Занурюємося…',
    'Погружение': 'Занурення',
    'Погружение не завершено': 'Занурення не завершено',
    'Погружение письма': 'Занурення листа',
    'Подавление сильнее согласия: новое «согласен» его не снимает. Снять может только человек — в разделе': 'Придушення сильніше за згоду: нова «згода» його не знімає. Зняти може лише людина — у розділі',
    'Подавления': 'Придушення',
    'Подавления адреса остаются — это минимальное доказательство отказа, чтобы повторный импорт не вернул адрес в рассылки. Журнал доставки писем живёт по своему сроку хранения.': 'Придушення адреси лишаються — це мінімальний доказ відмови, щоб повторний імпорт не повернув адресу до розсилок. Журнал доставки зберігається відповідно до строку зберігання.',
    'Подавлено': 'Придушено',
    'Подпись': 'Підпис',
    'Подробности счёта видят владелец и администраторы пространства.': 'Деталі рахунку бачать власник і адміністратори простору.',
    'Подтверждён': 'Підтверджено',
    'Подтверждённые домены': 'Підтверджені домени',
    'Подытог': 'Проміжна сума',
    'Позиция': 'Позиція',
    'Поиск — по точному адресу, его началу (от 3 символов) или external_id.': 'Пошук за точною адресою, її початком (від 3 символів) або external_id.',
    'Пока ни одного домена': 'Доменів поки немає',
    'Пока тихо': 'Поки тихо',
    'Показано {a} из {b}.': 'Показано {a} з {b}.',
    'Показать раньше': 'Показати раніше',
    'Получатель, тема или msg_…': 'Отримувач, тема або msg_…',
    'Получить API-ключ': 'Отримати API-ключ',
    'Понял вопрос так:': 'Я зрозумів питання так:',
    'Попробуйте изменить фильтры или отправьте письмо через API.': 'Спробуйте змінити фільтри або надішліть лист через API.',
    'Последнее событие': 'Остання подія',
    'Последнее событие:': 'Остання подія:',
    'Последние 14 дней в океане {name}.': 'Останні 14 днів в океані {name}.',
    'Последние письма': 'Останні листи',
    'Последняя проверка: {when}': 'Остання перевірка: {when}',
    'Поток': 'Потік',
    'Почтовик': 'Поштовий сервіс',
    'Почтовик, период и тип проблемы распознаются в вопросе. Без периода смотрим последние 7 дней, максимум — 30. Данные других рабочих пространств не участвуют.': 'Поштовий сервіс, період і тип проблеми розпізнаються з питання. Без періоду дивимося останні 7 днів, максимум — 30. Дані інших просторів не використовуються.',
    'Права': 'Права',
    'Править HTML и текст': 'Редагувати HTML і текст',
    'Превышение не блокирует отправку.': 'Перевищення не блокує надсилання.',
    'Предпросмотр': 'Попередній перегляд',
    'Предпросмотр письма': 'Попередній перегляд листа',
    'Префикс mo_live_ или mo_test_ помогает не перепутать окружения': 'Префікс mo_live_ або mo_test_ допомагає не сплутати середовища',
    'Прилив месяца': 'Приплив місяця',
    'Прилив писем': 'Приплив листів',
    'Принято': 'Прийнято',
    'Принято провайдером': 'Прийнято провайдером',
    'Провайдер': 'Провайдер',
    'Проверен': 'Перевірено',
    'Проверить DNS': 'Перевірити DNS',
    'Проверьте адрес сайта': 'Перевірте адресу сайту',
    'Проверьте поля формы': 'Перевірте поля форми',
    'Проверяем…': 'Перевіряємо…',
    'Продолжить': 'Продовжити',
    'Продукт': 'Продукт',
    'Пропустить': 'Пропустити',
    'Пропустить и открыть бэкофис': 'Пропустити й відкрити бекофіс',
    'Просрочен': 'Прострочено',
    'Профиль': 'Профіль',
    'Профиль компании': 'Профіль компанії',
    'Профиль сохранён': 'Профіль збережено',
    'Публикация': 'Публікація',
    'Путь каждого письма с точностью до миллисекунды': 'Шлях кожного листа з точністю до мілісекунди',
    'Работает после публикации. Idempotency-Key — по одному на событие (заказ, запрос сброса): повтор запроса не создаст второе письмо.': 'Працює після публікації. Idempotency-Key — один на подію (замовлення, запит скидання): повторний запит не створить другий лист.',
    'Рабочий email': 'Робочий email',
    'Раздельные потоки: отписка от рассылок не блокирует сброс пароля': 'Окремі потоки: відписка від розсилок не блокує скидання пароля',
    'Режим': 'Режим',
    'Режим песочницы: письмо проходит весь путь внутри MailOcean, но наружу не уходит.': 'Режим пісочниці: лист проходить весь шлях усередині MailOcean, але назовні не надсилається.',
    'Реквизиты для оплаты': 'Реквізити для оплати',
    'Риф: ключ для вашего кода': 'Риф: ключ для вашого коду',
    'Роль «наблюдатель» может смотреть черновики, но не создавать их.': 'Роль «спостерігач» може переглядати чернетки, але не створювати їх.',
    'Русский': 'Російська',
    'С': 'З',
    'С возвращением на борт': 'Із поверненням на борт',
    'Сайт': 'Сайт',
    'Светлая': 'Світла',
    'Сгенерировать черновик': 'Згенерувати чернетку',
    'Сгенерируйте первый — он появится здесь.': 'Згенеруйте першу — вона з’явиться тут.',
    'Сегмент': 'Сегмент',
    'Секрет подписи (показывается один раз)': 'Секрет підпису (показується один раз)',
    'Сеть недоступна. Попробуйте ещё раз.': 'Мережа недоступна. Спробуйте ще раз.',
    'Скачать CSV': 'Завантажити CSV',
    'Скопировать реквизиты': 'Скопіювати реквізити',
    'Скопируйте ключ сейчас — после обновления страницы он больше не будет показан.': 'Скопіюйте ключ зараз — після оновлення сторінки його більше не буде показано.',
    'Скрытая копия': 'Прихована копія',
    'Слишком много попыток. Подождите минуту.': 'Забагато спроб. Зачекайте хвилину.',
    'Смена тарифа — это заявка менеджеру: он подтвердит условия и выставит счёт. Деньги автоматически не списываются.': 'Зміна тарифу — це запит менеджеру: він підтвердить умови й виставить рахунок. Кошти автоматично не списуються.',
    'Сменить тариф': 'Змінити тариф',
    'Собираем черновик…': 'Збираємо чернетку…',
    'Событий нет. Их передают через': 'Подій немає. Їх передають через',
    'Событий пока нет': 'Подій поки немає',
    'События': 'Події',
    'Совет: используйте поддомен, например mail.вашсайт.com — так репутация рассылок не смешивается с основным доменом': 'Порада: використовуйте піддомен, наприклад mail.вашсайт.com — так репутація розсилок не змішується з основним доменом',
    'Согласие': 'Згода',
    'Согласие на маркетинг': 'Згода на маркетинг',
    'Согласие на маркетинг здесь не ставится: его записывают с источником и доказательством в карточке контакта или через API.': 'Згоду на маркетинг тут не ставлять: її записують із джерелом і доказом у картці контакту або через API.',
    'Содержимое удалено после отправки — храним только метаданные': 'Вміст видалено після надсилання — зберігаємо лише метадані',
    'Создайте ключ, чтобы отправлять письма из своего кода.': 'Створіть ключ, щоб надсилати листи з вашого коду.',
    'Создан': 'Створено',
    'Создать': 'Створити',
    'Создать аккаунт': 'Створити обліковий запис',
    'Создать вебхук': 'Створити вебхук',
    'Создать ключ': 'Створити ключ',
    'Состояние моря': 'Стан моря',
    'Сотрудник MailOcean': 'Співробітник MailOcean',
    'Сохраните ключ в менеджере секретов или переменной окружения MAILOCEAN_API_KEY. После закрытия шага он скрывается навсегда.': 'Збережіть ключ у менеджері секретів або змінній середовища MAILOCEAN_API_KEY. Після закриття кроку його буде приховано назавжди.',
    'Сохранить': 'Зберегти',
    'Спросите словами. Ответ собирается из событий ваших писем, кодов SMTP, подавлений и проверки DNS — каждый вывод ссылается на события, письма или проверку DNS.': 'Запитайте своїми словами. Відповідь складається з подій ваших листів, кодів SMTP, придушень і перевірки DNS — кожен висновок посилається на події, листи або перевірку DNS.',
    'Спросить': 'Запитати',
    'Срок оплаты': 'Строк оплати',
    'Статус': 'Статус',
    'Сумма': 'Сума',
    'Схема атрибутов': 'Схема атрибутів',
    'Сценарии': 'Сценарії',
    'Счета': 'Рахунки',
    'Счета, суммы и реквизиты для оплаты видят владелец и администраторы пространства.': 'Рахунки, суми та реквізити для оплати бачать власник і адміністратори простору.',
    'Счетов пока нет': 'Рахунків поки немає',
    'Считаются письма, принятые провайдером. Тестовые письма мастера онбординга ({n}) в объём не входят.': 'Враховуються листи, прийняті провайдером. Тестові листи майстра онбордингу ({n}) до обсягу не входять.',
    'Счёт': 'Рахунок',
    'Счёт выставляется вручную, оплата не списывается автоматически. Единица учёта — письмо, принятое провайдером (не получатель).': 'Рахунки виставляються вручну, оплата не списується автоматично. Одиниця обліку — лист, прийнятий провайдером (а не отримувач).',
    'Счёт не найден.': 'Рахунок не знайдено.',
    'Также подавить адрес для маркетинга': 'Також придушити адресу для маркетингу',
    'Также подходит: {list}': 'Також підходить: {list}',
    'Таких событий нет': 'Таких подій немає',
    'Такой алиас уже занят — выберите «новая версия» или смените алиас': 'Такий аліас уже зайнятий — оберіть «нова версія» або змініть аліас',
    'Такой контакт уже был — обновили': 'Такий контакт уже був — оновили',
    'Тариф': 'Тариф',
    'Тариф и оплата': 'Тариф і оплата',
    'Тариф не назначен — напишите менеджеру.': 'Тариф не призначено — напишіть менеджеру.',
    'Теги и метаданные': 'Теги та метадані',
    'Текст': 'Текст',
    'Тема': 'Тема',
    'Тема · отправитель': 'Тема · відправник',
    'Тема:': 'Тема:',
    'Тестовый': 'Тестовий',
    'Тип': 'Тип',
    'Тип письма': 'Тип листа',
    'Тихой ночи': 'Тихої ночі',
    'Только https и публичный адрес': 'Лише https і публічна адреса',
    'Топ за 7 дней': 'Топ за 7 днів',
    'Транзакционные': 'Транзакційні',
    'Транзакционные письма для продуктов, которым нельзя терять ни одного чека, кода или подтверждения.': 'Транзакційні листи для продуктів, яким не можна втрачати жодного чека, коду чи підтвердження.',
    'Транзакционные письма согласия не требуют. Нет записи — маркетинг не отправляется. Действует самая поздняя по времени запись.': 'Транзакційні листи згоди не потребують. Немає запису — маркетинг не надсилається. Діє найпізніший за часом запис.',
    'Транзакционный': 'Транзакційний',
    'Тёмная': 'Темна',
    'Удалить {key}': 'Видалити {key}',
    'Удалить атрибут {key}?': 'Видалити атрибут {key}?',
    'Удалить домен {name}? Отправка с него сразу прекратится.': 'Видалити домен {name}? Надсилання з нього одразу припиниться.',
    'Удалить навсегда': 'Видалити назавжди',
    'Удалить по GDPR': 'Видалити за GDPR',
    'Удалить черновик': 'Видалити чернетку',
    'Удалить черновик? Опубликованные из него шаблоны останутся.': 'Видалити чернетку? Опубліковані з неї шаблони залишаться.',
    'Удалятся контакт, его атрибуты, события, согласия и членство в сегментах. Отменить нельзя.': 'Буде видалено контакт, його атрибути, події, згоди та членство в сегментах. Скасувати неможливо.',
    'Уже есть аккаунт?': 'Вже є обліковий запис?',
    'Уже опубликован: v{v} ·': 'Уже опубліковано: v{v} ·',
    'Устно по телефону 11.10, звонок №1234': 'Усно по телефону 11.10, дзвінок №1234',
    'Устройство не поддерживает passkeys или вход отменён.': 'Пристрій не підтримує passkeys або вхід скасовано.',
    'ФИНИШ': 'ФІНІШ',
    'Цвет бренда': 'Колір бренду',
    'Цена': 'Ціна',
    'Часовой пояс:': 'Часовий пояс:',
    'Черновики': 'Чернетки',
    'Черновиков пока нет': 'Чернеток поки немає',
    'Что': 'Що',
    'Что будете отправлять?': 'Що надсилатимете?',
    'Что делают ваши контакты: заказы, корзины, входы. По событиям строятся сегменты и сценарии. Повтор с тем же': 'Що роблять ваші контакти: замовлення, кошики, входи. За подіями будуються сегменти й сценарії. Повтор із тим самим',
    'ШАГ {n} ИЗ 5': 'КРОК {n} З 5',
    'Шаблон': 'Шаблон',
    'Шельф: ваш домен отправки': 'Шельф: ваш домен відправлення',
    'Эмуляция почтового клиента в тёмной теме (Apple Mail, iOS, Outlook.com). Gmail тёмные правила игнорирует и показывает светлую версию — она тоже читаемая.': 'Емуляція поштового клієнта в темній темі (Apple Mail, iOS, Outlook.com). Gmail ігнорує темні правила й показує світлу версію — вона теж читабельна.',
    'Этот passkey не подошёл. Войдите паролем.': 'Цей passkey не підійшов. Увійдіть за паролем.',
    'Я сохранил ключ': 'Я зберіг ключ',
    'Язык': 'Мова',
    'адрес': 'адресу',
    'архетип': 'архетип',
    'архетип без AI': 'архетип без AI',
    'без ключа': 'без ключа',
    'бесплатно': 'безкоштовно',
    'в выборке': 'у вибірці',
    'в существующую. Две записи SPF делают проверку недействительной.': 'до наявного. Два SPF-записи роблять перевірку недійсною.',
    'ваш-домен.com': 'ваш-домен.com',
    'версия {v}': 'версія {v}',
    'волна,': 'хвиля,',
    'все': 'усі',
    'все почтовики': 'усі поштові сервіси',
    'все проблемы': 'усі проблеми',
    'вход': 'вхід',
    'готово': 'готово',
    'да': 'так',
    'до {n} в день': 'до {n} на день',
    'доменов: {n}': 'доменів: {n}',
    'домены без ограничения': 'домени без обмежень',
    'доставлено по событиям: {n}': 'доставлено за подіями: {n}',
    'журнал {n} дн.': 'журнал {n} дн.',
    'за 14 дней': 'за 14 днів',
    'записал: {who}': 'записав: {who}',
    'записано {date}': 'записано {date}',
    'значение': 'значення',
    'и покажем его путь по шагам.': 'і покажемо його шлях крок за кроком.',
    'из {included} · {pct}%': 'з {included} · {pct}%',
    'ключ': 'ключ',
    'контакт': 'контакт',
    'контрольная группа': 'контрольна група',
    'которая доходит до берега.': 'яка доходить до берега.',
    'медиана {v}': 'медіана {v}',
    'найдено': 'знайдено',
    'не облагается в v1': 'не оподатковується в v1',
    'не отправлялись': 'не надсилались',
    'не повторяются сами': 'не повторюються самі',
    'не проверено': 'не перевірено',
    'не совпадает': 'не збігається',
    'не создаёт второе событие.': 'не створить другу подію.',
    'нет': 'ні',
    'нет записи': 'немає запису',
    'новую версию шаблона «{name}» (v{v}). Письма по алиасу «{alias}» сразу начнут уходить в новом виде.': 'нову версію шаблону «{name}» (v{v}). Листи за аліасом «{alias}» одразу почнуть надсилатися в новому вигляді.',
    'новый шаблон «{name}» с алиасом «{alias}».': 'новий шаблон «{name}» з аліасом «{alias}».',
    'норма < 0,1%': 'норма < 0,1%',
    'норма < 2%': 'норма < 2%',
    'обязательно': 'обов’язково',
    'оплачен {date}': 'сплачено {date}',
    'опубликован v{v}': 'опубліковано v{v}',
    'от': 'від',
    'от переданных': 'від переданих',
    'отзыв': 'відкликання',
    'открыть шаблон': 'відкрити шаблон',
    'отозван': 'відкликано',
    'по домену получателя и MX': 'за доменом отримувача та MX',
    'подтверждён {when}': 'підтверджено {when}',
    'позже': 'пізніше',
    'показаны последние 20 000': 'показано останні 20 000',
    'последние 50': 'останні 50',
    'пояс пространства': 'часовий пояс простору',
    'принято {d}': 'прийнято {d}',
    'проблемы': 'проблеми',
    'рекомендуется': 'рекомендовано',
    'с адреса': 'з адреси',
    'сверх лимита {sum} / 1 000': 'понад ліміт {sum} / 1 000',
    'система': 'система',
    'согласие': 'згода',
    'текст: {model}': 'текст: {model}',
    'текущий': 'поточний',
    'удалено': 'видалено',
    'участия контакта': 'участі контакту',
    'черновик': 'чернетка',
    'шаг {n}': 'крок {n}',
    '— без адреса —': '— без адреси —',
    '— не по теме вопроса': '— не за темою питання',
    '⚡ транз.': '⚡ транзакц.',
    '🌊 маркет.': '🌊 маркет.',
    'Отправка писем': 'Надсилання листів',
    'Чтение писем и статусов': 'Читання листів і статусів',
    'Изменение подавлений': 'Зміна придушень',
    'Чтение подавлений': 'Читання придушень',
    'Чтение контактов, событий и сегментов': 'Читання контактів, подій і сегментів',
    'Изменение контактов и сегментов, удаление по GDPR': 'Зміна контактів і сегментів, видалення за GDPR',
    'Передача событий': 'Передача подій',
    'Чтение сценариев, статистики и отчётов; симуляции нужен и contacts:read': 'Читання сценаріїв, статистики та звітів; для симуляції також потрібен contacts:read',
    'Сценарии как код: версии, запрос согласования, публикация согласованного, пауза, зачисление': 'Сценарії як код: версії, запит на погодження, публікація погодженої версії, пауза, зарахування',
    'Вход': 'Вхід',
    'Вход с 2FA': 'Вхід з 2FA',
    'Вход по коду восстановления': 'Вхід за кодом відновлення',
    'Сброс пароля': 'Скидання пароля',
    'Создан API-ключ': 'Створено API-ключ',
    'Отозван API-ключ': 'Відкликано API-ключ',
    'Добавлен домен': 'Додано домен',
    'Проверка DNS': 'Перевірка DNS',
    'Удалён домен': 'Домен видалено',
    'Тестовое письмо': 'Тестовий лист',
    'Адрес в подавлениях': 'Адресу в списку придушення',
    'Адрес убран из подавлений': 'Адресу прибрано зі списку придушення',
    'Создан вебхук': 'Створено вебхук',
    'Удалён вебхук': 'Вебхук видалено',
    'Ping вебхука': 'Ping вебхука',
    'Приглашение': 'Запрошення',
    'Приглашение отозвано': 'Запрошення відкликано',
    'Приглашение принято': 'Запрошення прийнято',
    'Смена роли': 'Зміна ролі',
    'Участник удалён': 'Учасника видалено',
    'Создан шаблон': 'Створено шаблон',
    'Новая версия шаблона': 'Нова версія шаблону',
    'Удалён шаблон': 'Шаблон видалено',
    'Настройки пространства': 'Налаштування простору',
    'Новое пространство': 'Новий простір',
    'Онбординг завершён': 'Онбординг завершено',
    '2FA включён': '2FA увімкнено',
    '2FA выключен': '2FA вимкнено',
    'Новые коды восстановления': 'Нові коди відновлення',
    'Добавлен passkey': 'Додано passkey',
    'Удалён passkey': 'Passkey видалено',
    'Вход с passkey': 'Вхід з passkey',
    'Экспорт журнала': 'Експорт журналу',
    'Подтвердить домен': 'Підтвердити домен',
    'Создать API-ключ': 'Створити API-ключ',
    'Отправить первое письмо': 'Надіслати перший лист',
    'Подключить вебхук': 'Підключити вебхук',
    'Пробный период': 'Пробний період',
    'Активен': 'Активний',
    'Есть просроченный счёт': 'Є прострочений рахунок',
    'Завершён': 'Завершено',
    'после подтверждения домена': 'після підтвердження домену',
    'выделенный IP': 'виділена IP-адреса',
    'SLA': 'SLA',
    'строка': 'рядок',
    'число': 'число',
    'да / нет': 'так / ні',
    'дата': 'дата',
    'дата и время': 'дата і час',
    'список строк': 'список рядків',
    'жёсткий отскок': 'жорсткий відскок',
    'жалоба на спам': 'скарга на спам',
    'отписка': 'відписка',
    'вручную': 'вручну',
    'ящик переполнен 3 раза за 30 дней': 'поштову скриньку переповнено 3 рази за 30 днів',
    'маркетинг': 'маркетинг',
    'Почему падают письма на Apple?': 'Чому не доходять листи на Apple?',
    'Жалобы на спам в Gmail за неделю': 'Скарги на спам у Gmail за тиждень',
    'Что с письмами с неизвестным исходом?': 'Що з листами з невідомим результатом?',
    'Почему письма уходят в спам у Яндекса?': 'Чому листи потрапляють у спам у Яндекса?',
    'Hard bounce на mail.ru за 3 дня': 'Hard bounce на mail.ru за 3 дні',
    'Критично': 'Критично',
    'Внимание': 'Увага',
    'К сведению': 'До відома',
    'отказы': 'відскоки',
    'SPF / DKIM / DMARC': 'SPF / DKIM / DMARC',
    'письмо': 'лист',
    'событие': 'подія',
    'домен': 'домен',
    'подавление': 'придушення',
    'outbox': 'outbox',
    'В очереди': 'У черзі',
    'Передано': 'Передано',
    'Доставлено': 'Доставлено',
    'Отскок': 'Відскок',
    'Жалоба': 'Скарга',
    'Ошибка': 'Помилка',
    'Неизвестно': 'Невідомо',
    'Отменено MailOcean': 'Скасовано MailOcean',
    'Принято API, ждёт передачи провайдеру': 'Прийнято API, очікує передачі провайдеру',
    'Провайдер принял письмо': 'Провайдер прийняв лист',
    'Почтовый сервер получателя подтвердил приём': 'Поштовий сервер отримувача підтвердив прийом',
    'Постоянный отказ сервера получателя': 'Постійна відмова сервера отримувача',
    'Получатель отметил письмо как спам — добавлен в подавления': 'Отримувач позначив лист як спам — додано до списку придушення',
    'Провайдер окончательно отклонил письмо': 'Провайдер остаточно відхилив лист',
    'Результат передачи неизвестен; повторно не отправляем, чтобы не создать дубль': 'Результат передачі невідомий; повторно не надсилаємо, щоб не створити дубль',
    'Адрес в списке подавлений — письмо не отправлялось': 'Адреса у списку придушення — лист не надсилався',
    'Отменено сотрудником MailOcean до передачи провайдеру — письмо не отправлялось': 'Скасовано співробітником MailOcean до передачі провайдеру — лист не надсилався',
    'Поверхность': 'Поверхня',
    'Шельф': 'Шельф',
    'Риф': 'Риф',
    'Глубина': 'Глибина',
    'Бездна': 'Безодня',
    'Впадина': 'Западина',
    'Компания и цели': 'Компанія і цілі',
    'SPF, DKIM, DMARC': 'SPF, DKIM, DMARC',
    'Доступ для кода': 'Доступ для коду',
    'Живой путь в мс': 'Живий шлях у мс',
    'События в ваш сервер': 'Події на ваш сервер',
    'Готово': 'Готово',
    '0 м': '0 м',
    '50 м': '50 м',
    '200 м': '200 м',
    '1 000 м': '1 000 м',
    '4 000 м': '4 000 м',
    '11 000 м': '11 000 м',
    '⚡ Транзакционные': '⚡ Транзакційні',
    '🌊 Маркетинговые': '🌊 Маркетингові',
    '🐋 И то, и другое': '🐋 І те, і інше',
    'Чеки, коды, сброс пароля, уведомления': 'Чеки, коди, скидання пароля, сповіщення',
    'Рассылки, акции, цепочки': 'Розсилки, акції, ланцюжки',
    'Раздельные потоки в одном аккаунте': 'Окремі потоки в одному обліковому записі',
    'до 10 тыс.': 'до 10 тис.',
    '10–100 тыс.': '10–100 тис.',
    '100 тыс. – 1 млн': '100 тис. – 1 млн',
    'больше 1 млн': 'понад 1 млн',
  },
};
